import styles from "./Selfie.module.scss";
import { CustomButton } from "../../components";
import { useEffect } from "react";
import { googleEvent_LOJ218, googleEvent_LOJ220 } from "../../lib/google-analytics-loan-journey-events";
import { updateCameraAllowPermission } from "../../redux/slices/registerSlice";
import { useDispatch } from "react-redux";

export default function AllowCameraPermission() {
  useEffect(() => {
    googleEvent_LOJ218();
  }, []);
    const dispatch = useDispatch();

  return (
    <div className={`wrapper auto-height ${styles.selfie__permission__page}`}>
      <img src="/images/camera-permission.png" width="220" alt="" />
      <h2>Allow Camera Permission for KYC Selfie</h2>
      <p>To complete your KYC, we need to verify your identity with a quick selfie.</p>

      <ul>
        <li>1. Capture a live selfie for identity verification</li>
        <li>2. Ensure security and prevent fraud</li>
        <li>3. Quick and seamless process</li>
      </ul>

      <div className="mb-2">
        <CustomButton
          text="Allow Camera Permission"
          onClick={() => {
            dispatch(updateCameraAllowPermission(true));
            googleEvent_LOJ220();
          }}
        />
      </div>
    </div>
  );
}
